// ----------------------------------------------------------------------------
// Snippet: Variant Picker
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_variant-picker.scss';

// Variables
const SELECTOR_WRAPPER_CLASS = '.selector-wrapper';

// Functions
class VariantPicker extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
        this.productSelect = document.querySelector('[data-product-select]');
        this.lowInventoryMessageEnabled = this.productSelect.dataset.lowInventoryMessageEnabled;
        this.lowInventoryThreshold = parseInt(this.productSelect.dataset.lowInventoryThreshold);
        this.lowInventoryContainer = document.querySelector('.low-inventory__container');
    }

    connectedCallback() {
        this.onVariantChange();
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantStatuses();

        if (typeof this.lowInventoryMessageEnabled !== "undefined" && this.lowInventoryMessageEnabled == "true" && typeof this.lowInventoryThreshold !== "undefined") {
            const currentVariantQuantity = parseInt(this.productSelect.selectedOptions[0].dataset.inventoryQuantity);

            if (currentVariantQuantity <= this.lowInventoryThreshold && currentVariantQuantity > 0) {
                this.lowInventoryContainer.style.display = "block";
            } else {
                this.lowInventoryContainer.style.display = "none";
            }
        }
    }

    // Update the selected options. Example of what the options array looks like: ["Blue", "Small"]
    updateOptions() {
        const selectorWrappers = Array.from(this.querySelectorAll(SELECTOR_WRAPPER_CLASS));
        this.options = selectorWrappers.map((selectorWrapper) => {
            if (selectorWrapper.classList.contains('form__field--swatches')) {
                return Array.from(selectorWrapper.querySelectorAll('input')).find((radio) => radio.checked).value;
            } else {
                return selectorWrapper.querySelector('select').value;
            }
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });

        if(this.currentVariant !== undefined) {
            document.querySelector('[data-product-form]').dataset.currentVariantId = this.currentVariant.id; // Update the attribute
        }
    }

    updateVariantStatuses() {
        // Get all the possible variants based on the selected option one (including unavailable/sold out variants).
        const selectedOptionOneValue = this.options[0];
        const selectedOptionOneVariants = this.variantData.filter(
            (variant) => {
                return variant.option1 === selectedOptionOneValue;
            }
        );

        const selectorWrappers = this.querySelectorAll(SELECTOR_WRAPPER_CLASS);

        // Looping through each option selector (exclude the option1 selector since we only need to update the availability status on option 2 and 3 when applicable)
        selectorWrappers.forEach((option, index) => {
            if (index === 0) return;

            // Getting all the inputs of the current selector
            const optionInputs = option.querySelectorAll('input[type="radio"], option');

            // Get the selected option value of the previous selector.
            const previousOptionSelected = this.options[index - 1];

            // Get all the available options of the current selector
            const availableOptionInputsValue = selectedOptionOneVariants
                .filter((variant) => variant[`option${index}`] === previousOptionSelected)
                .map((variantOption) => variantOption[`option${index + 1}`]);

            // If the currently selected option2 is invalid, reset it to the first available
            if (!availableOptionInputsValue.includes(this.options[index])) {
                // Force a new selection in the DOM:
                if (option.classList.contains('form__field--custom-select')) {
                    const selectEl = option.querySelector('select');
                    if (availableOptionInputsValue.length) {
                        selectEl.value = availableOptionInputsValue[0];
                        this.options[index] = availableOptionInputsValue[0];
                        // Trigger the event so the theme updates URL, etc.
                        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                } else {
                    const firstAvailableRadio = [...optionInputs]
                        .find(radio => availableOptionInputsValue.includes(radio.value));
                    if (firstAvailableRadio) {
                        firstAvailableRadio.checked = true;
                        this.options[index] = firstAvailableRadio.value;
                        // Trigger the event so the theme updates URL, etc.
                        firstAvailableRadio.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            }

            // Update the availability status of the current selector
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
        // Re-sync the overall variant state
        this.updateOptions();
        this.updateMasterId();

        // Update the hidden productSelect so the correct variant is selected
        if (this.currentVariant) {
            this.productSelect.value = this.currentVariant.id;
            // If needed, trigger an event so your theme updates the button
            this.productSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
            const swatchOption = input.closest('.swatch__option');
            if (swatchOption) {
                // For swatches: toggle the disabled class on the label.
                if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                    swatchOption.querySelector('.form__option-label').classList.remove('swatch--disabled');
                } else {
                    swatchOption.querySelector('.form__option-label').classList.add('swatch--disabled');
                }
            } else if (input.tagName.toLowerCase() === 'option') {
                // For dropdown options: disable if not available.
                input.disabled = !listOfAvailableOptions.includes(input.value);
            }
        });
    }

}

customElements.define('iam-variant-picker', VariantPicker);


